export const ChapterContent = ({ children }: any) => <div className="bg-white flex basis-full">{children}</div>;
